module.exports = __webpack_public_path__ + "static/media/linkedin.74e6d01e.svg";